import React, { useState } from 'react';
import { TextField, Button, Container, Typography, Grid, Box, Paper } from '@mui/material';

export default function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: '',
  });

  const [messageSent, setMessageSent] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

 const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:5001';

const handleSubmit = async (e) => {
  e.preventDefault();
  setErrorMessage('');

  try {
    const response = await fetch(`${apiUrl}/api/contact`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(formData),
    });

    const data = await response.json();

    if (response.ok) {
      setMessageSent(true);
    } else {
      setErrorMessage(data.error || 'Okänt fel vid skickning.');
    }
  } catch (error) {
    setErrorMessage('Kunde inte skicka meddelandet. Försök igen senare.');
    console.error('Fel vid e-postsändning:', error);
  }
};


  const handleReset = () => {
    setFormData({ name: '', email: '', message: '' });
    setErrorMessage('');
  };

  const handleNewMessage = () => {
    setMessageSent(false);
    handleReset();
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: '#f5f5f5',
        py: 4,
      }}
    >
      <Container
        maxWidth="md"
        sx={{
          flexGrow: 1,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'flex-start',
          py: 6,
          pb: 10,
        }}
      >
        <Paper
          sx={{
            padding: '3rem',
            borderRadius: '12px',
            boxShadow: 6,
            maxWidth: '700px',
            margin: '0 auto',
            backgroundColor: '#fff',
            mb: 6,
          }}
        >
          {messageSent ? (
            <Box sx={{ textAlign: 'center', mb: 4 }}>
              <Typography
                variant="h4"
                component="h2"
                color="textSecondary"
                gutterBottom
                sx={{ fontWeight: 'bold' }}
              >
                Tack för ditt meddelande!
              </Typography>

              <Typography variant="h6" color="textSecondary" sx={{ mb: 3 }}>
                Vi återkommer till dig så snart som möjligt.
              </Typography>
              <Button
                variant="contained"
                color="primary"
                size="large"
                onClick={handleNewMessage}
              >
                Skicka ett nytt meddelande
              </Button>
            </Box>
          ) : (
            <>
              <Box sx={{ textAlign: 'center', marginBottom: '1.5rem' }}>
                <Typography
                  variant="h5"
                  component="h1"
                  gutterBottom
                  sx={{ fontWeight: 'bold' }}
                >
                  Kontakta Oss
                </Typography>
                <Typography
                  variant="subtitle1"
                  color="textSecondary"
                  sx={{ fontSize: '1.15rem' }}
                >
                  Vi ser fram emot att höra från dig. Fyll i formuläret nedan för att kontakta oss.
                </Typography>
              </Box>

              <Box
                component="form"
                onSubmit={handleSubmit}
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: 3,
                  backgroundColor: 'background.paper',
                  padding: 3,
                  borderRadius: 2,
                }}
              >
                <TextField
                  label="*Namn"
                  variant="outlined"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  fullWidth
                  size="medium"
                  sx={{
                    width: {
                      xs: '100%',   // 100% bredd på små skärmar
                      sm: '90%',
                      md: '100%',
                    },
                    mx: 'auto',
                  }}
                />

                <TextField
                  label="*E-post"
                  variant="outlined"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  fullWidth
                  type="email"
                  size="medium"
                  sx={{
                    width: {
                      xs: '100%',
                      sm: '90%',
                      md: '100%',
                    },
                    mx: 'auto',
                  }}
                />

                <TextField
                  label="*Meddelande"
                  variant="outlined"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  required
                  fullWidth
                  multiline
                  rows={6}
                  inputProps={{ maxLength: 500 }}
                  size="medium"
                  sx={{
                    width: {
                      xs: '100%',
                      sm: '90%',
                      md: '100%',
                    },
                    mx: 'auto',
                  }}
                />

                <Typography variant="body2" color="textSecondary" align="center">
                  Max 500 tecken.
                </Typography>

                {errorMessage && (
                  <Typography variant="body2" color="error" align="center">
                    {errorMessage}
                  </Typography>
                )}

                <Grid container spacing={2}>
                  <Grid item xs={6}>
                    <Button
                      variant="outlined"
                      color="secondary"
                      onClick={handleReset}
                      fullWidth
                      size="large"
                    >
                      Återställ
                    </Button>
                  </Grid>

                  <Grid item xs={6}>
                    <Button
                      variant="contained"
                      color="primary"
                      type="submit"
                      fullWidth
                      size="large"
                    >
                      Skicka
                    </Button>
                  </Grid>
                </Grid>
              </Box>
            </>
          )}
        </Paper>

        {!messageSent && (
          <Typography
            variant="body2"
            color="textSecondary"
            align="center"
            sx={{ mt: 3 }}
          >
            * Obligatoriska fält
          </Typography>
        )}
      </Container>
    </Box>
  );
}
